export default __webpack_public_path__ + "static/media/next.b27f5db5.png";